import React, {useRef} from 'react';

import Button from '../../../common-women/Button';

export default function UploadButton({ changeConnectionInfo }) {
    const fileFinderRef = useRef(null); // 파일 탐색기
  
    const openFileFinder = () => {
        fileFinderRef.current.click();
    };
  
    const changeFileList = (e) => {
        if (e.target.files.length > 0) {
            changeConnectionInfo('dbFileName', e.target.files[0].name);
            changeConnectionInfo('dbFile', e.target.files[0]);
            e.target.value = ''; // 파일 input 초기화
        }
    };

    return (
        <div>
            <Button
                text='찾아보기'
                width='92px'
                height='46px'
                padding='14px 20px'
                backgroundColor='#EFEFEF'
                borderRadius='5px'
                fontSize='15px'
                fontWeight='500'
                textColor='#74737C'
                onClick={openFileFinder}
            />
            <input
                ref={fileFinderRef}
                style={{ display: 'none' }}
                type='file'
                onChange={changeFileList}
                accept='.db,.sqlite,.sqlite3'  // 허용할 확장자 지정
            />
        </div>
    );
}
